import { Injectable } from '@angular/core';
import { DataCollectorService } from '../../core/services/data_collector_services/data_collector_service.service';
import { LocalStorageService } from '../../core/services/localstorage.service';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataGridService {
  public isActionPerformed: Subject<boolean | string> = new Subject<boolean | string>();
  get saveFilterApi(): any{
    return `${this.datacollectorservice.baseurl()}/misc/quick_filters`;
  }
  public appliedFilter: Subject<string> = new Subject<string>();
  public reloadQuickFilters: Subject<boolean> = new Subject<boolean>();
  public summaryFilterapplied: Subject<any> = new Subject<any>();
  public summaryfilterchanged: Subject<boolean> = new Subject<boolean>();

  constructor(private datacollectorservice: DataCollectorService,
              private _localStorageService: LocalStorageService){
    this.isActionPerformed.next(false);
    this.reloadQuickFilters.next(false);
    this.summaryFilterapplied.next(false);
    this.summaryfilterchanged.next(false);
    this.appliedFilter.next(null);
  }

  setModuleSummaryFilter(filterRules,module): void{
    this._localStorageService.setLocalStorage(`${module.toLowerCase()}_filter_rules_summary`,filterRules);
    this._localStorageService.setLocalStorage(`${module.toLowerCase()}_filter_rules`,filterRules);
    this.summaryFilterapplied.next({filterRules: filterRules, module: module});
  }
}
